export default "__VITE_ASSET__BLVaWaC1__"